/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";

function Footer({ company, links }) {
  const { href, name } = company;

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={1.5}>
        <Link href={link.href} target="_blank" rel="noreferrer" underline="hover">
          <MDTypography variant="button" fontWeight="regular" color="text.secondary">
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      component="footer"
      width="100%"
      py={2}
      px={1.5}
      mt="auto"
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems="center"
      bgcolor="white"
      borderTop="1px solid #E5E7EB"
    >
      <MDTypography variant="caption" color="text.secondary">
        © {new Date().getFullYear()} — <strong>{name}</strong>
      </MDTypography>
      <MDBox
        component="ul"
        display="flex"
        alignItems="center"
        p={0}
        m={0}
        style={{ listStyle: "none" }}
      >
        {renderLinks()}
      </MDBox>
    </MDBox>
  );
}

// Default props
Footer.defaultProps = {
  company: { href: "https://www.creative-tim.com/", name: "Creative Tim" },
  links: [
    { href: "https://www.creative-tim.com/", name: "Creative Tim" },
    { href: "https://www.creative-tim.com/presentation", name: "About Us" },
    { href: "https://www.creative-tim.com/blog", name: "Blog" },
    { href: "https://www.creative-tim.com/license", name: "License" },
  ],
};

// PropTypes
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
